module.exports = {
	"header": "Acheter sur __brand__ <small>Caractéristiques de l'acheteur et services</small>",
	"paragraph1": "__brand__ vous donne la possibilité de participer à des encans à travers le monde ou tout près de chez vous, si vous n'avez pas le temps ou l'envie de sortir.",
	"paragraph2": "Vous pouvez également participer aux encans et enchérir en utilisant votre ordinateur ou votre dispositif mobile.",
	"bidLive": {
		"header": "Enchérir en temps réel sur les articles",
		"paragraph1": "Vous pouvez enchérir en temps réel sur les articles en utilisant votre ordinateur ou votre dispositif mobile, partout dans le monde, et ce, aussi longtemps que vous disposez d'une connexion internet."
	},
	"participate": {
		"header": "Participer à plusieurs encans en simultané",
		"paragraph1": "Vous pouvez visionner et enchérir en simultané dans tous les encans de votre choix. Il n'y a aucune limite dans le nombre d'enchères auxquelles vous pouvez participer simultanément.",
		"paragraph2": "Il n'y a aucune limite de notre côté, la seule limite est au niveau de votre bande passante internet. En participant à un encan en temps réel, assurez-vous de la stabilité et de la rapidité de votre connexion internet."
	},
	"absenteeBidding": {
		"paragraph1": "Si vous n'êtes pas en mesure d'être devant votre ordinateur au moment de l'enchère, vous pouvez toujours remporter un lot en faisant une pré-offre. Si vous avez demandé à ce que votre offre soit considérée comme étant un maximum, notre système enchérira automatiquement à votre place en inscrivant votre offre en tête!"
	},
	"bidderDashboard": {
		"header": "Tableau de bord de l'acheteur",
		"paragraph1": "Vous pouvez revoir vos anciennes offres, les offres d'achat et les articles remportés en utilisant le tableau de bord de l'acheteur."
	},
	"askQuestion": {
		"header": "Poser des questions",
		"paragraph1": "Posez des questions aux encanteurs à propos de l'article ou de l'évènement lui-même."
	},
	"notifications": {
		"header": "Avis",
		"paragraph1": "Soyez avisé avant les événements ou lorsque certains articles qui correspondent à vos intérêts sont répertoriés sur __brand__."
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/buying.json5
// module id = 1972
// module chunks = 6